/* THE BEAM theme sections: buy box, tabs, filters, carousel, radar demo. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function press(btn, on) { btn.setAttribute('aria-pressed', on ? 'true' : 'false'); }
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var value = (cents / 100);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, kind) {
      var str;
      if (kind === 'amount_no_decimals') {
        str = Math.round(value).toLocaleString('en-US');
      } else if (kind === 'amount_with_comma_separator') {
        str = value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } else {
        str = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      return str.replace(/[.,]00$/, '');
    });
  }

  /* Header menu */
  function initHeader() {
    $$('[data-tb-menu]').forEach(function (btn) {
      if (btn.dataset.bound) return; btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var drawer = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (drawer) drawer.hidden = !open;
      });
    });
  }

  /* Carousel */
  function initCarousels() {
    $$('[data-tb-carousel]').forEach(function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';
      var track = $('.tb-car', root);
      $$('[data-tb-car]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          if (track) track.scrollBy({ left: Number(b.dataset.tbCar) * track.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
    });
  }

  /* Filter chips */
  function initFilters() {
    $$('[data-tb-filterable]').forEach(function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';
      var chips = $$('[data-tb-chip]', root);
      var items = $$('.tb-grid > *', root);
      var count = $('[data-tb-count]', root);
      function apply(key) {
        var shown = 0;
        items.forEach(function (el) {
          var keys = (el.getAttribute('data-tb-filter') || '').split(',');
          var on = !key || keys.indexOf(key) > -1;
          el.hidden = !on;
          if (on) shown++;
        });
        chips.forEach(function (c) { press(c, c.dataset.tbChip === key); });
        if (count) count.textContent = (count.dataset.tbCountLabel || '[count]').replace('[count]', shown);
      }
      chips.forEach(function (c) { c.addEventListener('click', function () { apply(c.dataset.tbChip); }); });
      apply('');
    });
  }

  /* Video band: swap in the embed on click */
  function initVideos() {
    $$('[data-tb-video-play]').forEach(function (btn) {
      if (btn.dataset.bound) return; btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var frame = btn.closest('[data-tb-video]');
        var tpl = frame && $('template', frame);
        if (!tpl) return;
        frame.innerHTML = '';
        frame.appendChild(tpl.content.cloneNode(true));
      });
    });
  }

  /* Feature cards with Shopify-hosted videos: play in a pop-up, stop on close */
  function initVideoDialogs() {
    $$('[data-tb-video-open]').forEach(function (btn) {
      if (btn.dataset.bound) return; btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var section = btn.closest('section');
        var dialog = section && $('[data-tb-video-dialog]', section);
        var tpl = btn.parentNode.querySelector('[data-tb-video-src]');
        if (!dialog || !tpl) return;
        var body = $('[data-tb-video-body]', dialog);
        body.innerHTML = '';
        body.appendChild(tpl.content.cloneNode(true));
        dialog.setAttribute('aria-label', btn.getAttribute('aria-label') || 'Video');
        dialog.showModal();
        var v = $('video', body);
        if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });
    $$('[data-tb-video-dialog]').forEach(function (dialog) {
      if (dialog.dataset.bound) return; dialog.dataset.bound = '1';
      dialog.addEventListener('close', function () { $('[data-tb-video-body]', dialog).innerHTML = ''; });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      $('[data-tb-video-close]', dialog).addEventListener('click', function () { dialog.close(); });
    });
  }

  /* Tabs, with links like #size-guide opening a tab */
  function selectTab(root, id) {
    $$('[data-tb-tab]', root).forEach(function (t) { t.setAttribute('aria-selected', t.dataset.tbTab === id ? 'true' : 'false'); });
    $$('[data-tb-panel]', root).forEach(function (p) { p.hidden = p.dataset.tbPanel !== id; });
  }
  function tabForHash(hash) {
    if (!hash) return null;
    var h = hash.replace('#', '');
    var btn = $('[data-tb-tab][data-hash="' + h + '"]');
    return btn ? { root: btn.closest('[data-tb-tabs]'), id: btn.dataset.tbTab } : null;
  }
  function initTabs() {
    $$('[data-tb-tabs]').forEach(function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';
      $$('[data-tb-tab]', root).forEach(function (t) {
        t.addEventListener('click', function () { selectTab(root, t.dataset.tbTab); });
      });
    });
    var hit = tabForHash(location.hash);
    if (hit) { selectTab(hit.root, hit.id); hit.root.scrollIntoView(); }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname) return;
    var hit = tabForHash(url.hash);
    if (!hit) return;
    e.preventDefault();
    selectTab(hit.root, hit.id);
    hit.root.scrollIntoView({ behavior: 'smooth' });
    history.replaceState(null, '', url.hash);
  });

  /* Radar demo */
  function initRadar() {
    $$('[data-tb-radar]').forEach(function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';
      var input = $('[data-tb-rd-input]', root);
      var car = $('[data-tb-rd-car]', root);
      var data = JSON.parse($('[data-tb-rd-data]', root).textContent);
      var alertM = Number(root.dataset.alert), warnM = Number(root.dataset.warn), maxM = Number(root.dataset.max);
      var zone = $('[data-tb-rd-zone]', root), dist = $('[data-tb-rd-dist]', root);
      var cards = $$('.tb-rd__card', root), presets = $$('.tb-rd__preset', root);
      function update() {
        var d = Number(input.value);
        var cls = d > warnM ? 'out' : (d >= alertM ? 'warn' : 'alert');
        var z = data[cls];
        dist.textContent = d;
        zone.textContent = z.name;
        zone.className = 'tb-rd__pill tb-rd__pill--' + cls;
        for (var i = 0; i < 3; i++) { var o = $('[data-tb-rd-out="' + (i + 1) + '"]', root); if (o) o.textContent = z.t[i]; }
        cards.forEach(function (c) { c.classList.toggle('is-out', cls === 'out'); c.classList.toggle('is-alert', cls === 'alert'); });
        presets.forEach(function (b) { press(b, Number(b.dataset.v) === d); });
        input.setAttribute('aria-valuetext', d + ' metres behind you');
        car.style.left = (d / maxM * 100) + '%';
      }
      input.addEventListener('input', update);
      presets.forEach(function (b) { b.addEventListener('click', function () { input.value = b.dataset.v; update(); }); });
      update();
    });
  }

  /* What you get: follows the chosen option */
  function initWhatYouGet() {
    $$('[data-tb-wyg]').forEach(function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';
      var title = $('[data-tb-wyg-title]', root);
      var tpl = root.dataset.template || '[name], [count] products';
      document.addEventListener('tb:bundle', function (e) {
        var d = e.detail;
        $$('[data-tb-wyg-item]', root).forEach(function (el) {
          var keys = el.dataset.bundles;
          el.hidden = !!keys && keys.split(',').indexOf(d.key) < 0;
        });
        if (title) title.textContent = d.count > 1 ? tpl.replace('[name]', d.title).replace('[count]', d.count) : d.title;
      });
    });
  }

  /* Visor guide cards tick buy-box add-ons */
  function initVisors() {
    $$('[data-tb-visors]').forEach(function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';
      $$('[data-tb-visor]', root).forEach(function (card) {
        card.addEventListener('click', function () { emit('tb:addon-toggle', { key: card.dataset.tbVisor }); });
      });
      document.addEventListener('tb:addons', function (e) {
        $$('[data-tb-visor]', root).forEach(function (card) {
          var on = e.detail.keys.indexOf(card.dataset.tbVisor) > -1;
          press(card, on);
          var act = $('.tb-visor__act', card);
          if (act) act.textContent = on ? (act.dataset.on || act.dataset.off) : act.dataset.off;
        });
      });
    });
  }

  /* Buy box */
  function initBuybox(root) {
    if (root.dataset.bound) return; root.dataset.bound = '1';
    var dataEl = $('[data-tb-product]', root);
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = $('[data-tb-form]', root);
    var input = $('[data-tb-variant-input]', root);
    var addBtn = $('[data-tb-add]', root);
    var totalEl = $('[data-tb-total]', root);
    var errorEl = $('[data-tb-error]', root);
    var stockEl = $('[data-tb-stock]', root);
    var badge = $('[data-tb-gal-badge]', root);
    var sticky = $('[data-tb-sticky]', root);
    var optionSets = $$('[data-tb-option]', root);
    var bundles = $$('[data-tb-bundle]', root);
    var mirrorFs = $('[data-tb-mirror-fs]', root);
    var setup = $('[data-tb-setup]', root);
    var choiceFs = $('[data-tb-choice]', root);
    var money = function (c) { return formatMoney(c, data.money_format); };

    var state = {
      bundle: data.default_bundle || null,
      mirror: data.mirror.key,
      choice: choiceFs ? ($('[aria-pressed="true"]', choiceFs) || {}).dataset.value : null
    };
    var params = new URLSearchParams(location.search);
    if (params.get('bundle') && $('[data-tb-bundle="' + params.get('bundle') + '"]', root)) state.bundle = params.get('bundle');

    function selectedValues() {
      return optionSets.map(function (fs) {
        var b = $('[data-value][aria-pressed="true"]', fs);
        return b ? b.dataset.value : null;
      });
    }
    function findVariant(values) {
      return data.variants.find(function (v) {
        return values.every(function (val, i) { return val === null || v.options[i] === val; });
      }) || null;
    }
    var variant = data.variants.find(function (v) { return String(v.id) === String(input.value); }) || data.variants[0];

    function mirrorBtn() { return $('[data-tb-mirror="' + state.mirror + '"]', root); }
    function bundleEl() { return state.bundle ? $('[data-tb-bundle="' + state.bundle + '"]', root) : null; }
    function bundleData(el) { return JSON.parse($('[data-tb-bundle-data]', el).textContent); }

    function bundleSaving(el) {
      var bd = bundleData(el);
      var off = Number(bd.off || 0);
      var save = (off > 0 && bd.main && variant) ? Math.floor(variant.price * off / 100) : 0;
      $$('[data-tb-free]', el).forEach(function (sel) {
        var opt = sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex] : sel;
        save += Number(opt.dataset.price || 0);
      });
      return save;
    }
    function bundlePrice(el) {
      var bd = bundleData(el);
      var sum = -bundleSaving(el);
      if (bd.main && variant) sum += variant.price;
      if (bd.mirror && mirrorBtn()) sum += Number(mirrorBtn().dataset.price);
      $$('[data-tb-item-variant]', el).forEach(function (sel) {
        var opt = sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex] : sel;
        sum += Number(opt.dataset.price || 0);
      });
      return sum;
    }
    function addonsTotal() {
      return $$('[data-tb-addon][aria-pressed="true"]', root).reduce(function (s, b) { return s + Number(b.dataset.price); }, 0);
    }
    function bundleCount(el) {
      var bd = bundleData(el);
      return (bd.main ? 1 : 0) + (bd.mirror ? 1 : 0) + $$('[data-tb-item-variant]', el).length;
    }

    function render() {
      var el = bundleEl();
      bundles.forEach(function (b) {
        var on = b === el;
        b.classList.toggle('is-on', on);
        $('.tb-opt__head', b).setAttribute('aria-expanded', on ? 'true' : 'false');
        $('[data-tb-bundle-price]', b).textContent = money(bundlePrice(b));
        var was = $('[data-tb-bundle-was]', b);
        if (was) was.textContent = money(bundlePrice(b) + bundleSaving(b));
      });
      var bd = el ? bundleData(el) : null;
      /* An add-on already inside the chosen option is hidden, so it can't be bought twice */
      var inBundle = el ? $$('[data-tb-item]', el).map(function (li) { return li.dataset.tbItem; }) : [];
      var addonEls = $$('[data-tb-addon]', root);
      addonEls.forEach(function (a) {
        var hide = !!a.dataset.product && inBundle.indexOf(a.dataset.product) > -1;
        if (hide && !a.dataset.bundled) { a.dataset.bundled = a.getAttribute('aria-pressed'); press(a, false); }
        else if (!hide && a.dataset.bundled) { press(a, a.dataset.bundled === 'true'); delete a.dataset.bundled; }
        a.style.display = hide ? 'none' : '';
      });
      var addonFs = addonEls.length ? addonEls[0].closest('fieldset') : null;
      if (addonFs) addonFs.hidden = addonEls.every(function (a) { return a.style.display === 'none'; });
      if (mirrorFs) mirrorFs.hidden = bundles.length > 0 && !(bd && bd.mirror);

      var total = (el ? bundlePrice(el) : (variant ? variant.price : 0)) + addonsTotal();
      totalEl.textContent = money(total);
      var instal = $('[data-tb-instal]', root);
      if (instal) instal.textContent = instal.dataset.template.replace('[amount]', money(Math.round(total / Number(instal.dataset.count))));

      var available = !!variant && variant.available;
      addBtn.disabled = !available;
      addBtn.textContent = available ? addBtn.dataset.label : addBtn.dataset.soldout;

      if (stockEl && variant) {
        var t = Number(stockEl.dataset.threshold);
        stockEl.hidden = !(variant.qty !== null && variant.qty > 0 && variant.qty <= t);
        stockEl.textContent = stockEl.dataset.template.replace('[count]', variant.qty);
      }
      var unit = $('[data-tb-unit-price]', root);
      if (unit && variant) unit.textContent = money(variant.price);

      if (setup && bd) {
        var covers = bd.covers.map(function (c) { return String(c).trim(); });
        var lis = $$('[data-tb-cover]', setup);
        var done = 0;
        lis.forEach(function (li) { var on = covers.indexOf(li.dataset.tbCover) > -1; li.classList.toggle('is-on', on); if (on) done++; });
        var head = $('p', setup);
        head.textContent = head.dataset.template.replace('[done]', done).replace('[total]', lis.length);
      }

      if (sticky) {
        $('[data-tb-sticky-label]', sticky).textContent = el ? el.dataset.title : (root.querySelector('h1') || {}).textContent;
        $('[data-tb-sticky-price]', sticky).textContent = money(total);
        var sb = $('[data-tb-sticky-btn]', sticky);
        sb.disabled = !available;
        sb.textContent = addBtn.textContent;
      }
      if (el) emit('tb:bundle', { key: state.bundle, title: el.dataset.title, count: bundleCount(el) });
    }

    function updateOptionAvailability() {
      var values = selectedValues();
      optionSets.forEach(function (fs, i) {
        $$('[data-value]', fs).forEach(function (btn) {
          var test = values.slice(); test[i] = btn.dataset.value;
          var match = data.variants.find(function (v) { return test.every(function (val, j) { return v.options[j] === val; }); });
          btn.classList.toggle('is-unavail', !match || !match.available);
        });
      });
    }

    function showMedia(id) {
      if (!id) return;
      var slides = $$('[data-media-id]', root);
      if (!slides.some(function (s) { return s.dataset.mediaId === String(id); })) return;
      slides.forEach(function (s) {
        s.hidden = s.dataset.mediaId !== String(id);
        var yt = $('iframe[src*="enablejsapi=1"]', s);
        if (yt) {
          if (s.hidden) {
            if (yt.contentWindow) yt.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (s.hasAttribute('data-tb-autoplay')) {
            /* Reloading with autoplay=1 works even when the hidden iframe never loaded */
            if (yt.src.indexOf('autoplay=1') === -1) yt.src = yt.src + '&autoplay=1';
            else if (yt.contentWindow) yt.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          }
        }
        var v = $('video', s);
        if (!v) return;
        if (s.hidden) { v.pause(); }
        else if (s.hasAttribute('data-tb-autoplay')) { v.muted = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      });
      $$('[data-tb-thumb]', root).forEach(function (t) { press(t, t.dataset.tbThumb === String(id)); });
    }

    function updateBadge() {
      if (!badge) return;
      var txt = badge.dataset.template;
      optionSets.forEach(function (fs) {
        var b = $('[data-value][aria-pressed="true"]', fs);
        if (b) txt = txt.split('[' + fs.dataset.name + ']').join(b.dataset.label || b.dataset.value);
      });
      badge.textContent = txt;
    }

    function onVariantChange() {
      variant = findVariant(selectedValues());
      if (variant) {
        input.value = variant.id;
        showMedia(variant.media);
        var url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url.toString());
      }
      updateOptionAvailability();
      updateBadge();
      render();
    }

    optionSets.forEach(function (fs) {
      var label = $('[data-tb-option-label]', fs);
      $$('[data-value]', fs).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('[data-value]', fs).forEach(function (b) { press(b, b === btn); });
          if (label) label.textContent = btn.dataset.label || btn.dataset.value;
          onVariantChange();
        });
      });
      $$('[data-tb-unit]', fs).forEach(function (u) {
        u.addEventListener('click', function () {
          $$('[data-tb-unit]', fs).forEach(function (x) { press(x, x === u); });
          $$('[data-cm]', fs).forEach(function (sm) { sm.textContent = u.dataset.tbUnit === 'in' ? sm.dataset.in : sm.dataset.cm; });
        });
      });
    });

    bundles.forEach(function (b) {
      $('.tb-opt__head', b).addEventListener('click', function () { state.bundle = b.dataset.tbBundle; render(); });
      $$('select[data-tb-item-variant]', b).forEach(function (sel) { sel.addEventListener('change', render); });
    });

    $$('[data-tb-mirror]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.mirror = btn.dataset.tbMirror;
        $$('[data-tb-mirror]', root).forEach(function (x) { press(x, x === btn); });
        $$('[data-tb-mirror-name]').forEach(function (n) { n.textContent = btn.dataset.name; });
        var img = $('img', btn);
        $$('[data-tb-mirror-thumb]', root).forEach(function (t) { t.innerHTML = img ? img.outerHTML : ''; });
        render();
      });
    });

    function addonKeys() { return $$('[data-tb-addon][aria-pressed="true"]', root).map(function (b) { return b.dataset.tbAddon; }); }
    function toggleAddon(btn) {
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      press(btn, btn.getAttribute('aria-pressed') !== 'true');
      emit('tb:addons', { keys: addonKeys() });
      render();
    }
    $$('[data-tb-addon]', root).forEach(function (btn) {
      btn.addEventListener('click', function (e) { if (e.target.closest('a')) return; toggleAddon(btn); });
      if (btn.tagName !== 'BUTTON') {
        btn.addEventListener('keydown', function (e) {
          if (e.target !== btn || (e.key !== 'Enter' && e.key !== ' ')) return;
          e.preventDefault(); toggleAddon(btn);
        });
      }
    });
    document.addEventListener('tb:addon-toggle', function (e) { toggleAddon($('[data-tb-addon="' + e.detail.key + '"]', root)); });

    if (choiceFs) {
      $$('[data-value]', choiceFs).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('[data-value]', choiceFs).forEach(function (b) { press(b, b === btn); });
          state.choice = btn.dataset.value;
          var l = $('[data-tb-choice-label]', choiceFs); if (l) l.textContent = btn.dataset.value;
        });
      });
    }

    $$('[data-tb-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.tbThumb); });
    });

    function lineItems() {
      var items = [];
      var el = bundleEl();
      var bd = el ? bundleData(el) : { main: true, mirror: false };
      var props = {};
      if (el && bundleCount(el) > 1) props._kit = el.dataset.title;
      if (bd.main && variant) {
        var mainProps = Object.assign({}, props);
        if (state.choice && data.choice) mainProps[data.choice] = state.choice;
        items.push({ id: variant.id, quantity: 1, properties: mainProps });
      }
      if (el) {
        $$('[data-tb-item-variant]', el).forEach(function (sel) { items.push({ id: Number(sel.value), quantity: 1, properties: props }); });
        if (bd.mirror && mirrorBtn()) items.push({ id: Number(mirrorBtn().dataset.variant), quantity: 1, properties: props });
      }
      $$('[data-tb-addon][aria-pressed="true"]', root).forEach(function (b) { items.push({ id: Number(b.dataset.variant), quantity: 1 }); });
      return items;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      errorEl.hidden = true;
      addBtn.setAttribute('aria-disabled', 'true');
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: lineItems() })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      }).then(function () {
        if (data.redirect) { window.location.href = root_url + 'cart'; return; }
        return fetch(root_url + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var c = $('[data-tb-cart-count]');
          if (c) c.textContent = cart.item_count;
          addBtn.textContent = 'Added';
          setTimeout(render, 1500);
        });
      }).catch(function (err) {
        errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
        errorEl.hidden = false;
      }).finally(function () { addBtn.removeAttribute('aria-disabled'); });
    });

    if (sticky) {
      $('[data-tb-sticky-btn]', sticky).addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : addBtn.click(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var shown = !entries[0].isIntersecting;
          sticky.classList.toggle('is-shown', shown);
          sticky.setAttribute('aria-hidden', shown ? 'false' : 'true');
          $('[data-tb-sticky-btn]', sticky).tabIndex = shown ? 0 : -1;
        }).observe(addBtn);
      }
    }

    updateOptionAvailability();
    updateBadge();
    render();
    emit('tb:addons', { keys: addonKeys() });
  }

  function initAll() {
    initHeader();
    initCarousels();
    initFilters();
    initVideos();
    initVideoDialogs();
    initTabs();
    initRadar();
    initWhatYouGet();
    initVisors();
    $$('[data-tb-buybox]').forEach(initBuybox);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
